import React from 'react';
import history from 'app/routes/history';
import _ from 'lodash';
import Button from 'app/components/general/Button';
import SectionGroup from 'app/components/general/SectionGroup';
import Tbody from 'app/components/general/Tbody';
import PaymentRow from 'app/components/teamPaymentRequests/PaymentRow';

interface IManageTeamPaymentsProps {
  actions: any;
  paymentsById: any;
  paymentIds: any;
  paymentCollectionsById: any;
  reminders: any;
  hasLoaded: any;
  isLoading: any;
}
export default class ManageTeamPayments extends React.Component<
  IManageTeamPaymentsProps
> {
  static defaultProps: IManageTeamPaymentsProps = {
    actions: undefined,
    paymentsById: undefined,
    paymentIds: undefined,
    paymentCollectionsById: undefined,
    reminders: undefined,
    hasLoaded: undefined,
    isLoading: false,
  };

  componentDidMount(): void {
    this.props.actions.getAllPayments();
  }

  handleCollect = (e): void => {
    e.preventDefault();
    history.push('/payment-requests/new');
  };

  relevantPaymentCollections(paymentId): any {
    return this.props.paymentCollectionsById.filter(
      (t) => t.payment.id === paymentId,
    );
  }

  renderPaymentRow(paymentId): React.ReactNode {
    const payment = this.props.paymentsById[paymentId];
    return (
      <PaymentRow
        key={payment.id}
        identifier={payment.id}
        payment={payment}
        team={payment.team}
        selectPayment={this.props.actions.selectPayment}
        createReminder={this.props.actions.createReminder}
        reminders={this.props.reminders}
        amount={payment.amount}
        payments={0}
        total={payment.total}
        pendingTeamMembers={payment.pending}
        collectedTeamMembers={payment.collected}
      />
    );
  }

  renderPaymentList(): React.ReactNode {
    if (this.props.paymentIds !== undefined) {
      return this.props.paymentIds.map((id) => this.renderPaymentRow(id));
    }
    return null;
  }

  render(): React.ReactNode {
    return (
      <SectionGroup
        title="Your Payment Requests"
        buttons={(
          <div className="row">
            <div className="col btn-flex-group">
              <div className="btn-flex-container thin-margin">
                <Button
                  className="btn-thinner btn-thin-margin btn-success"
                  isLoading={this.props.isLoading}
                  onClick={this.handleCollect}
                >
                  Request Payment
                </Button>
              </div>
            </div>
          </div>
        )}
      >
        <div className="row head-row">
          <div className="col col-5 col-md-4">Description</div>
          <div className="col col-3 col-md-3 d-none d-md-block">Amount</div>
          <div className="col col-3 col-md-2">Collected</div>
          <div className="col col-4 col-md-3" />
        </div>
        <Tbody name="payments" foundText="yet">{this.renderPaymentList()}</Tbody>
      </SectionGroup>
    );
  }
}
